export { default } from './RatedReviews'
export * from './RatedReviews'
